import { Link } from "@tanstack/react-router";
import { SITE } from "@/lib/site";
import { CATEGORIES } from "@/lib/blog";

export function Footer() {
  const highlightCategories = CATEGORIES.slice(0, 6);

  return (
    <footer className="mt-24 border-t-4 border-accent bg-primary text-primary-foreground">
      <div className="container-svg grid gap-10 py-14 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span aria-hidden className="inline-flex h-10 w-10 items-center justify-center rounded bg-accent font-bold text-primary text-lg leading-none">DC</span>
            <span className="flex flex-col leading-none">
              <span className="font-display text-xl font-bold">Dedetizadora Chapecó</span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-primary-foreground/70 mt-0.5">Controle de Pragas · SC</span>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm text-primary-foreground/80">
            {SITE.description}
          </p>
          <p className="mt-4 text-sm text-primary-foreground/80">
            <strong>Endereço:</strong> {SITE.address}<br />
            <strong>Horário:</strong> {SITE.hours}<br />
            <strong>Telefone:</strong> {SITE.phone}
          </p>
          <div className="mt-6">
            <a href={SITE.whatsappUrl} target="_blank" rel="noopener" className="btn-accent">Solicitar orçamento no WhatsApp</a>
          </div>
        </div>
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wide text-accent">Categorias</h3>
          <ul className="mt-4 space-y-2 text-sm text-primary-foreground/80">
            <li><Link to="/blog" className="hover:text-accent">Todos os artigos</Link></li>
            {highlightCategories.map((c) => (
              <li key={c}>
                <Link to="/blog" hash={`cat=${encodeURIComponent(c)}`} className="hover:text-accent">{c}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wide text-accent">A empresa</h3>
          <ul className="mt-4 space-y-2 text-sm text-primary-foreground/80">
            <li><Link to="/sobre" className="hover:text-accent">Sobre</Link></li>
            <li><Link to="/equipe" className="hover:text-accent">Equipe técnica</Link></li>
            <li><Link to="/blog" className="hover:text-accent">Blog</Link></li>
            <li><Link to="/contato" className="hover:text-accent">Contato</Link></li>
            <li><a href={`mailto:${SITE.email}`} className="hover:text-accent">{SITE.email}</a></li>
            <li><Link to="/admin" className="hover:text-accent">Área administrativa</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-foreground/20">
        <div className="container-svg flex flex-col items-start justify-between gap-2 py-6 text-xs text-primary-foreground/70 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} {SITE.name}. Todos os direitos reservados.</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <Link to="/termos-de-uso" className="hover:text-accent">Termos de Uso</Link>
            <Link to="/politica-de-privacidade" className="hover:text-accent">Política de Privacidade</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
